import * as React from "react";
import ConfigContext from "../context/ConfigContext";
import { HeaderSmileyIcon } from "./Icons";
import { EngagementConfiguration } from "../types";
import Header from "./Header";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface ChatInviteHeaderProps {
  agentName: string;
  agentHeadshotUrl: string;
  onClose: () => void;
}

class ChatInviteHeader extends React.Component<
  ChatInviteHeaderProps & ConfigExtension,
  {}
> {
  renderAgentHeadshot() {
    return (
      <div className="velaro-header-headshot" style={{ marginBottom: 20 }}>
        <img
          src={this.props.agentHeadshotUrl}
          alt={`${this.props.agentName} profile`}
        />
      </div>
    );
  }

  renderCompanyLogo() {
    const logoUrl = this.props.config.HeaderLogoUrl;

    if (!logoUrl) {
      return <HeaderSmileyIcon />;
    }

    return (
      <img className="velaro-header-logo" src={logoUrl} alt="Company logo" />
    );
  }

  renderHeaderImage() {
    switch (this.props.config.ChatHeaderImageType) {
      case "AgentHeadshot":
        return this.renderAgentHeadshot();
      case "CompanyLogo":
        return this.renderCompanyLogo();
      case "None":
        return null;
      default:
        throw new Error("unhandled ChatInviteHeaderImageType");
    }
  }

  render() {
    return (
      <Header
        isPopout={false}
        onCollapse={this.props.onClose}
        headerContent={
          <React.Fragment>{this.renderHeaderImage()}</React.Fragment>
        }
      />
    );
  }
}

export default (props: ChatInviteHeaderProps) => (
  <ConfigContext.Consumer>
    {config => <ChatInviteHeader config={config} {...props} />}
  </ConfigContext.Consumer>
);
